export const companyBrandingQueryKeys = {
  active: ['company', 'branding'] as const,
  admin: (companyId: string) => ['admin', 'companies', companyId, 'branding'] as const,
};
